import React, { memo } from 'react';
import { LayoutTariffs } from "../../../LayoutTariffs";
import { LayoutCard } from "../../../LayoutCard";
import { LayoutServices } from "../../../LayoutServices";
var BLOCKS_BY_TYPE = {
  card: LayoutCard,
  tariffs: LayoutTariffs,
  services: LayoutServices
};
export var TabContent = /*#__PURE__*/memo(function (_ref) {
  var type = _ref.type,
    data = _ref.data;
  if (!type || !data) {
    return null;
  }
  var Block = BLOCKS_BY_TYPE[type];
  return /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-TabContent"
  }, /*#__PURE__*/React.createElement(Block, data));
});